// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__qvDXD","content":"Footer_content__I5pao","info":"Footer_info__pO0rB","social":"Footer_social__93tJ+","social-button":"Footer_social-button__cKdpb"};